//import axios from 'axios';
import * as cookieUtil from '@/utils/cookieUtil';
import commonService from './common-service';

const Promise = require("bluebird");

function httpReq(method, url, params, data, auth, contentType) {
  const token = cookieUtil.get("token") || "";
  // var token = "eyJ0eXAiOiJKV1QiLCJjdHkiOiJKV1QiLCJ6aXAiOiJERUYiLCJhbGciOiJSUzUxMiJ9.eNqqVsrNT8rMSVWyUjI0tbQ0M7KwMDY0UdJRykxRsrIwBYoZ6SiVFqcW-SXmghQ9m9v3tLXj-ZT5QCWpFQVKVoampuZGRsaWFoa1AAAAAP__.TpY3tz9WSwUeBBbOwOQejZFy2Y6mjbqtOe35eCpW304NW-5rL2CDsRu3_Gg851InC_5sO1h_gHYLtek4bSC8ni37H-xng3uiMPgYzsaqFNRJ9_9YSY7yVunJc0hcY-HvBb5CJ19Z7LoAtOusxWDs3hv8UjYVDHe65nGoXo3dAs0";
  if (auth && !token) {
    commonService.authLoginWithWX();
  }
  if (!method || !url) {
    return Promise.reject("请求方法和请求链接不能为空");
  }
  return new Promise((resolve, reject) => {
    axios(url, {
      method,
      timeout: 30000,
      params,
      data,
      headers: {
        'X-Requested-With': 'XMLHttpRequest',
        'Content-Type': contentType || 'application/json;charset=UTF-8',
        product: 'admin',
        'access-token': token,
        hospital: cookieUtil.get('hospitalId')
      },
    }).then((res) => {
      if (res.status == 200) {
        if (res.data && res.data.errorCode == 10003) {
          cookieUtil.remove("token");
          cookieUtil.set("redirectUrl",window.location.pathname);
          commonService.authLoginWithWX();
        }
        resolve(res.data);
      } else {
        reject(res);
      }
    }).catch((err) => {
      reject(err);
    });
  });
}

function httpGet(url, params, token) {
  return httpReq(
    'get',
    url,
    params, {},
    token,
  );
}

function httpPost(url, data, token, contentType) {
  return httpReq(
    'post',
    url, {},
    data,
    token,
    contentType,
  );
}

function httpPut(url, data, token) {
  return httpReq(
    'put',
    url, {},
    data,
    token,
  );
}

function httpDelete(url, data, token) {
  return httpReq(
    'delete',
    url, {},
    data,
    token,
  );
}
function httpDeleteGet(url, data, token) {
  return httpReq(
    'delete',
    url,
    data, {},
    token,
  );
}

function httpPatch(url, params, token) {
  return httpReq(
    'patch',
    url,
    params, {},
    token,
  );
}

function httpAll() {}

export default {
  httpReq,
  httpGet,
  httpPost,
  httpPut,
  httpDelete,
  httpPatch,
  httpAll,
  httpDeleteGet,
};



// WEBPACK FOOTER //
// ./src/services/httpService.js